/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_GustsInputs */

const en_ui_weather_gusts = /** @type {(inputs: Ui_Weather_GustsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gusts`)
};

const de_ui_weather_gusts = /** @type {(inputs: Ui_Weather_GustsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böen`)
};

/**
* | output |
* | --- |
* | "Gusts" |
*
* @param {Ui_Weather_GustsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_gusts = /** @type {((inputs?: Ui_Weather_GustsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_GustsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_gusts(inputs)
	return de_ui_weather_gusts(inputs)
});